import type { ReactNode } from 'react';

/**
 * Empty state (§5.11): stroke glyph 48px in border-interactive (NEVER lime — empty is not
 * a signal), heading, one sentence, one primary action.
 */
export function EmptyState({
  icon,
  title,
  body,
  action,
}: {
  icon: ReactNode;
  title: string;
  body: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="mb-5 text-(--border-interactive)">{icon}</div>
      <h2 className="type-heading-1 text-primary">{title}</h2>
      <p className="type-body text-secondary mt-2 max-w-sm">{body}</p>
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
}
